import { Text } from '@v2/design-system';
import type { OrderProductCard } from '../types';
import DealDeliveryPreference from './DealDeliveryPreference';

type Props = {
    dealId: number;
    products: OrderProductCard[];
};

function isActiveReservation(status?: string | null): boolean {
    return status === 'reserved' || status === 'pending' || status === 'approved';
}

export default function DealFulfillmentToolbar({ dealId, products }: Props) {
    if (products.length === 0) {
        return null;
    }

    const fromStock = products.reduce((s, p) => {
        if (isActiveReservation(p.stock_request?.status)) {
            return s + (p.stock_request?.qty_approved ?? p.stock_request?.qty_requested ?? p.qty_from_stock ?? 0);
        }
        return s + (p.qty_from_stock ?? 0);
    }, 0);
    const toImport = products.reduce((s, p) => s + (p.qty_to_import ?? Math.round(p.quantity)), 0);

    return (
        <div className="mb-3 flex flex-wrap items-center gap-3 rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs dark:border-zinc-700 dark:bg-zinc-900">
            <Text className="font-medium text-gray-700 dark:text-zinc-200">Fulfillment</Text>
            <span className="text-emerald-700 dark:text-emerald-300">Estoque reservado: {fromStock}</span>
            <span className="text-sky-700 dark:text-sky-300">A importar: {toImport}</span>
            {fromStock > 0 && toImport > 0 && (
                <span className="ml-auto">
                    <DealDeliveryPreference dealId={dealId} />
                </span>
            )}
        </div>
    );
}
